import React from 'react';
import { Grid } from 'semantic-ui-react';
import Button from '@material-ui/core/Button';
import Server from '../../../functions/server'
import $ from "jquery";
import CircularProgress from '@material-ui/core/CircularProgress';

class Delete extends React.Component {

  state = {
    load: false,
    message: ''
  }

  delete() {
    let context = this;
    let id = this.props.id;
    let data1 = { 'id': id }
    this.setState({
      load: true,
      message: 'Deleting Part Alias Name!!!!',
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/deletebrand.php',
      success: function(data)
      {
        context.setState({ load: false })
        console.log(data);
        if (data == 1) {
          context.props.upData();
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    const { load } = this.state;
    return (
      <div>

        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            Do you want to remove it
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <center><Button onClick={ () => { this.props.handleClose(); }}>cancel</Button></center>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
          {load ?
            (<div><center><CircularProgress size={18} color='secoundary' /></center></div>)
           :
            (<div><center><Button onClick={this.delete.bind(this)}>Yes</Button></center></div>)
          }

          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default Delete;
